export const typeMonthSelector = (isoMonth, isoYear, selectYear, month) => {
  let typeMonth

  if (isoMonth < month.getMonth()) {
    typeMonth = 0
  } else if (isoMonth > month.getMonth()) {
    typeMonth = 2
  } else {
    typeMonth = 1
  }

  if (isoYear !== selectYear) {
    typeMonth = 3
  }

  return typeMonth
}